/** Cognito prefixes errors from its Lambda triggers with "PreSignUp failed with error "; users only need the reason */
export function cognitoTriggerMessage(message: string): string {
    return message.replace(/^\w+ failed with error\s*/i, "").trim();
}
